import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {FormGroup, Label, FormFeedback, Dropdown, DropdownToggle, DropdownMenu, DropdownItem} from 'reactstrap';
import { metadataService } from '../../_services';
import { BsFillCaretDownFill } from "react-icons/bs";


export class SlDropdown extends Component {
    constructor(props) {
        super(props);
    }
    
    
    displayText = () => {
        let option = this.props.options.find(x => x.value.toString() === this.props.value.toString());
        return option ? option.text || "" : metadataService.getLabel('Select') ;
    } 

    render() {
        return (
            <FormGroup>
                <Label for={this.props.name} hidden={!this.props.showLabel} className={this.props.isRequired && !this.props.disabled ? "required text-input-label" : "text-input-label"}>
                    {metadataService.getFieldNameLabel(this.props.customLabel ? this.props.customLabel : this.props.Name)}
                </Label><br />
                <Dropdown value={this.props.value} disabled={this.props.disabled} className={"Sl-dropdown"} isOpen={this.props.open} toggle={this.props.openDropdown}>
                    <DropdownToggle className={"sl-dropdown-toggle"}>
                        <div className={"sl-dropdown-toggle-content"}>
                            <div className={"sl-dropdown-value-display"}>
                                {(this.props.value ? this.displayText() : metadataService.getLabel('Select')) }
                            </div>
                            <div className={"sl-dropdown-caret"}>
                                <BsFillCaretDownFill />
                            </div>
                        </div>
                    </DropdownToggle>
                    <DropdownMenu value={this.props.value} className={"sl-dropdown-menu"}>
                        <div>
                            <DropdownItem value={''}>{(this.props.placeholder ? this.props.placeholder : metadataService.getLabel('Select')) }</DropdownItem>
                            <DropdownItem divider />
                            {this.props.options.map((option) => {
                                return (
                                    <div key={option.value}>
                                        <DropdownItem className={this.props.value === option.value ? `sl-dropdown-item sl-dropdown-item-selected` : `sl-dropdown-item`} name={this.props.Name} value={option.value} onClick={this.props.handleChange}>{option.text ? option.text : option.value }</DropdownItem>
                                        <DropdownItem divider />
                                    </div>
                                )
                            })}
                        </div>
                    </DropdownMenu>
                </Dropdown>
            </FormGroup>

        )
    }
}


//Define prop types
SlDropdown.propTypes = {
    Name: PropTypes.string,
    options: PropTypes.array.isRequired,
    handleChange: PropTypes.func.isRequired,
    openDropdown: PropTypes.func,
    value: PropTypes.string,
    error: PropTypes.string,
    placeholder: PropTypes.string,
    showLabel: PropTypes.bool,
    isRequired: PropTypes.bool,
    customLabel: PropTypes.string,
    open: PropTypes.bool,
    disabled: PropTypes.bool
}
SlDropdown.defaultProps = {
    disabled:false,
    showLabel: true,
    isRequired: true
}


// WEBPACK FOOTER //
// ./src/components/editors/SlDropdown.jsx